export const studentsDataOptions = [
	{ value: 'cs50x', label: 'Data Structure' },
	{ value: 'is41', label: 'Database' },
	{ value: 'ai61', label: 'Nueral Networking' },
];
